import { API } from "./axiosInstance"

/**
 * Gets all the contactReasons from usermanagement-service
 * @returns the contactReasons
 */
export const getContactReasons = async () => {
  const contactReasons = await API.get(`/contactReasons`);
  return contactReasons.data;
}
